import React from 'react';
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CNavLink,
  CNavItem,
  CButton,
} from '@coreui/react'
import { AppHeaderDropdown } from './header/index'
import { useKeycloak } from "@react-keycloak/web";
import { useTour } from '@reactour/tour';
import { useLocation, useNavigate } from 'react-router-dom';
import apurvaLogo from '../assets/images/apurva-light-logo.png'

const AppHeader = () => {
  const { keycloak } = useKeycloak();
  const { setIsOpen } = useTour();
  const navigate = useNavigate();
  const location = useLocation();
  const isReportEditorPage = /^\/dashboard\/[^/]+$/.test(location.pathname);

  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    fontSize: '0.85rem'
  };

  const handleReportEditorTour = () => {
    setIsOpen(true);
  }

  return (
    <CHeader position="fixed" style={{ padding: "5px" }}>
      <CContainer fluid>
        <CHeaderBrand className="mx-auto d-md-none fixed" to="/">
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto" style={{ gap: '20px', alignItems: 'center' }}>
          {!!keycloak.authenticated && (
            <CNavItem>
              <a className="navbar-brand" href="https://apurva.ai" style={{ margin: 0 }}>
                <img src={apurvaLogo} alt="Apurva Logo" style={{ height: '40px', width: 'auto', marginRight: '15px' }} />
              </a>
            </CNavItem>
          )}
          {isReportEditorPage && (
            <CNavItem>
              <CButton
                variant="ghost"
                onClick={() => navigate('/dashboard')}
                style={buttonStyle}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-left"><path d="m12 19-7-7 7-7" /><path d="M19 12H5" /></svg>
                Back to Dashboard
              </CButton>
            </CNavItem>
          )}
        </CHeaderNav>
        <CHeaderNav style={{ gap: '15px', alignItems: 'center' }}>
          <CNavItem>
            {!keycloak.authenticated && (
              <CNavLink href="#" onClick={() =>
                keycloak.login()}>Login</CNavLink>
            )}
            {isReportEditorPage && (
              <CButton
                variant="ghost"
                onClick={handleReportEditorTour}
                style={buttonStyle}
              >
                Start Tour
              </CButton>
            )}
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav className="ms-3">
          <AppHeaderDropdown username={keycloak.tokenParsed.preferred_username} />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
